// extracted by mini-css-extract-plugin
module.exports = {"EmptyState":"empty_state_EmptyState__1mXZ-","illustration":"empty_state_illustration__3PDvR","details":"empty_state_details__T5i1B"};